<template></template>

<script>
import countDown from "~/components/countDown";
import countTime from "~/components/countTime";
import lotteryNumber from "@p/bet/lotteryNumber";
import lotteryNumberDF from "@p/bet/lotteryNumberDF";
import { Format } from "~/assets/libs/timeOptions";

export default {
  data() {
    return {
      lotteryMixList: [], // 热门彩种和开奖时间融合的列表
    };
  },
  computed: {
    // 配置
    appConfig() {
      return this.$store.state.service.appConfig;
    },
    // 配置
    sitConfig() {
      return this.$store.state.service.siteConfig;
    },
    // 热门彩种
    hotLotteryList() {
      return this.$store.state.lottery.hotLotteryList;
    },
    lotteryLatelyLpVo() {
      return this.$store.state.lottery.LotteryLatelyLpVo;
    },
    lotteryTypes() {
      return this.$store.state.lottery.lotteryTypes;
    },
    // 新闻
    newslist() {
      return this.$store.state.news.newsList;
    }
  },
  watch: {
    //将开奖时间和热门彩种合成一个列表
    lotteryLatelyLpVo() {
      this.createLotteryMixList()
    },
    hotLotteryList() {
      this.createLotteryMixList()
    },
  },
  methods: {
    // 彩种列表和开奖彩种合并
    createLotteryMixList() {
      let lotteryList = this.hotLotteryList;
      let TimeList = this.lotteryLatelyLpVo;
      // console.log(22, lotteryList)
      let newList = [];
      lotteryList.forEach((lottery, index) => {
        TimeList.forEach((time, index) => {
          if (lottery.lotteryCode == time.lotteryCode) {
            newList.push(Object.assign({}, lottery, time));
          }
        });
      });

      this.lotteryMixList = [...newList];
    },
    //开奖时间应该显示哪一期啊
    lotteryOpenPeriods(lottery) {
      // 如果开奖倒计时目前是当前期 说明有当前期
      if (lottery.status == "current") {
        return lottery.last;
      } else if (lottery.status == "next" && lottery.current) {
        //未开盘没有current
        return lottery.current;
      } else if (lottery.status == "next") {
        return lottery.last;
      } else {
        //啥都没？？？
        console.warn("啥都没？？？");
        return false;
      }
    },
    async endCountDown(item, date) {
      item.status = "next";
      //没有current 说明还未开盘
      if (item.current == undefined && this.loadingnew == false) {
        //开盘时间到立刻取数据 不等20s
        this.loadingnew = true;
        console.warn("开盘时间到立刻取数据 不等20s", this.lotteryCode);
        await this.$store.dispatch("lottery/getLotteryLatelyLoop");
        this.loadingnew = false;
      }

    },
  },
  mounted() {
    // 避免相同页面多个组件重复请求
    if (this.disableMixinMounted) return
    this.$store.dispatch("service/getServiceTime"); // 获取服务器时间
    this.$store.dispatch("lottery/getLotteryLatelyLoop"); // 定时任务
  },
  beforeDestroy() {
    // this.$store.commit("lottery/setLotteryLatelyLpVo", []);
    this.$store.commit("lottery/clearLotteryLatelyTimer");
  },
  components: {
    countDown,
    lotteryNumber,
    lotteryNumberDF,
    countTime
  }
};
</script>